class HelpCenter {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('[data-tab]');
    this.panels = container.querySelectorAll('.help-center__content-panel');
    this.init();
  }

  init() {
    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchTab(tab.dataset.tab);
      });
    });

    // Handle URL hash for deep linking
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      const tab = this.container.querySelector(`[data-tab="${hash}"]`);
      if (tab) {
        this.switchTab(hash);
      }
    }

    // Initialize accordion toggles
    this.initAccordionToggles();

    // Initialize back button
    this.initBackButton();
  }

  initBackButton() {
    const backButton = this.container.querySelector('[data-back-button]');
    if (backButton) {
      backButton.addEventListener('click', () => {
        this.hideContentOnMobile();
      });
    }
  }

  initAccordionToggles() {
    const accordionToggles = this.container.querySelectorAll('[data-accordion-toggle]');
    
    accordionToggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const accordionId = toggle.dataset.accordionToggle;
        this.toggleAccordion(accordionId);
      });
    });
  }

  toggleAccordion(accordionId) {
    const toggle = this.container.querySelector(`[data-accordion-toggle="${accordionId}"]`);
    const content = this.container.querySelector(`[data-accordion-content="${accordionId}"]`);
    
    if (!toggle || !content) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const newState = !isExpanded;

    toggle.setAttribute('aria-expanded', newState);
    
    if (newState) {
      // Expand
      content.removeAttribute('data-accordion-collapsed');
      // Set max-height to actual height for smooth transition
      const height = content.scrollHeight;
      content.style.maxHeight = height + 'px';
      // After transition, remove inline style to allow natural height
      setTimeout(() => {
        if (content.getAttribute('data-accordion-collapsed') !== 'true') {
          content.style.maxHeight = '';
        }
      }, 300);
    } else {
      // Collapse
      const height = content.scrollHeight;
      content.style.maxHeight = height + 'px';
      // Force reflow
      content.offsetHeight;
      // Set collapsed state and height
      content.setAttribute('data-accordion-collapsed', 'true');
      content.style.maxHeight = '0px';
    }
  }

  switchTab(tabId) {
    // Update active tab
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === tabId;
      tab.classList.toggle('help-center__nav-link--active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    // Update active panel
    this.panels.forEach((panel) => {
      const isActive = panel.id === `content-${tabId}`;
      if (isActive) {
        panel.classList.add('help-center__content-panel--active');
        panel.removeAttribute('hidden');
        panel.setAttribute('aria-hidden', 'false');
      } else {
        panel.classList.remove('help-center__content-panel--active');
        panel.setAttribute('hidden', '');
        panel.setAttribute('aria-hidden', 'true');
      }
    });

    // Update URL hash without scrolling
    if (history.replaceState) {
      history.replaceState(null, null, `#${tabId}`);
    }

    // Mobile: Show content in full screen
    if (window.innerWidth < 990) {
      this.showContentOnMobile();
    }
  }

  showContentOnMobile() {
    const container = this.container.querySelector('.help-center__container');
    const backButton = this.container.querySelector('[data-back-button]');
    const content = this.container.querySelector('.help-center__content');
    
    if (container && backButton && content) {
      container.classList.add('help-center__container--content-view');
      backButton.removeAttribute('hidden');
      content.style.display = 'block';
      
      // Force reflow for transition
      content.offsetHeight;
      content.style.opacity = '1';
      
      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  hideContentOnMobile() {
    const container = this.container.querySelector('.help-center__container');
    const backButton = this.container.querySelector('[data-back-button]');
    const content = this.container.querySelector('.help-center__content');
    
    if (container && backButton && content) {
      // Fade out content
      content.style.opacity = '0';
      
      setTimeout(() => {
        container.classList.remove('help-center__container--content-view');
        backButton.setAttribute('hidden', '');
        content.style.display = 'none';
      }, 300);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHelpCenter);
} else {
  initHelpCenter();
}

function initHelpCenter() {
  const helpCenterContainer = document.querySelector('.help-center');
  if (helpCenterContainer && !helpCenterContainer.helpCenterInstance) {
    helpCenterContainer.helpCenterInstance = new HelpCenter(helpCenterContainer);
  }
}

